import {
  SHOW_PROGRESS,
  HIDE_PROGRESS,
  INDETERMINATE_PROGRESS_SHOW,
  INDETERMINATE_PROGRESS_HIDE
} from "./constants.js";

const regex = /^(progressComponent\/)/;

const _SHOW_PROGRESS = SHOW_PROGRESS.replace(regex, "");
const _HIDE_PROGRESS = HIDE_PROGRESS.replace(regex, "");

export default {
  [_SHOW_PROGRESS]({ commit }, description) {
    commit(INDETERMINATE_PROGRESS_SHOW, description);
  },
  [_HIDE_PROGRESS]({ commit }, description) {
    commit(INDETERMINATE_PROGRESS_HIDE, description);
  }
};
